module.exports = __webpack_public_path__ + "static/media/buy-merch.651ec6cb.png";